import { Track } from "../../AudioManager";
import { SetStyles, Point, Size, CreateElement, LogGroup} from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { CometDefault } from "./CometDefault";
export class CometBlue extends CometDefault
{
    protected override topCenterOffset: number = 0.42//0.42;
    protected override bottomCenterOffset: number= 0.05//0.197;
    /** for take this info need take the point for top of comment and div between total height , its the same for the other value but only need know where commets start anim 
     * 159 / 600 = 0.265;
     * 567 / 600 = 0.945;
    */
    protected override rotateOrigin: string = "50% 94%";
    public override PrepareResources(resourceManager: IWriteOnlyResourceManager): void {
        resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources/cometShortBlue", ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet"), true, LogGroup.Global.Add("BonusWinShow").Add("Commet"), true))
        this.audio.AddTrack(new Track(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources/tracks/cometShortBlue" + Settings.audioFormat, this.resid.ScopedResourceName("comet")));
    }    
}